// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { ReturnOrder, returnOrderSchema } from '@/return-order/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the resync return order API endpoint.
 */
const resyncReturnOrderResponseSchema = z.object({
  data: returnOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Re-fetches a 3PL-bound return order from the provider and reprocesses it,
 * regardless of its current status.
 *
 * @param returnOrderKey - The key of the return order to resync
 * @returns The reprocessed return order
 */
export async function resyncReturnOrder(
  returnOrderKey: string
): Promise<ReturnOrder> {
  const url = `/v1/return-order/${returnOrderKey}/resync`;
  const response = await api.post(url, {});

  const { data } = await parseResponse(
    resyncReturnOrderResponseSchema,
    response.data,
    {
      schemaName: 'ResyncReturnOrder',
      endpoint: url,
    }
  );
  return data;
}
